export const family = {
  roboto: 'Roboto',
};

export const weight = {
  regular: 400,
  medium: 500,
};
